function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.15 63.77c1.54-1.72 9.2-8.6 15.44-14.19C78.25 40 83.38 35.35 84.27 34.04c1.37-2.02 3.93-7.35-1.88-13.17-5.08-5.08-10.87-2.92-13.48-.84-2.23 1.78-12.55 13.66-16.07 17.74-.5.58-.69 26-.69 26zm-3.47-22.04c-1.54 1.72-9.2 8.6-15.44 14.19-10.67 9.58-15.8 14.23-16.69 15.55-1.37 2.02-3.93 7.35 1.88 13.17 5.08 5.08 10.87 2.92 13.48.84 2.23-1.78 12.55-13.66 16.07-17.74.5-.59.7-26.01.7-26.01z",
  fill: "#4dbfd9"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.49 47.06l-6.59-6.59a6.03 6.03 0 010-8.52l.39-.39a6.03 6.03 0 018.52 0l6.59 6.59a6.03 6.03 0 010 8.52l-.39.39a6.03 6.03 0 01-8.52 0zm.95-13.81a3.869 3.869 0 00-5.47 0l-.38.38a3.869 3.869 0 000 5.47l6.28 6.28a3.869 3.869 0 005.47 0l.38-.38a3.869 3.869 0 000-5.47l-6.28-6.28z",
  fill: "#1e1e1c"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 57.01,
  cy: 36.77,
  r: 1.3,
  fill: "#1e1e1c"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 62.11,
  cy: 41.88,
  r: 1.3,
  fill: "#1e1e1c"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.6 65.61l-6.59-6.59a6.03 6.03 0 010-8.52l.39-.39a6.03 6.03 0 018.52 0l6.59 6.59a6.03 6.03 0 010 8.52l-.39.39c-2.34 2.35-6.17 2.35-8.52 0zm.95-13.81a3.869 3.869 0 00-5.47 0l-.38.38a3.869 3.869 0 000 5.47l6.28 6.28a3.869 3.869 0 005.47 0l.38-.38a3.869 3.869 0 000-5.47l-6.28-6.28z",
  fill: "#1e1e1c"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 38.12,
  cy: 55.32,
  r: 1.3,
  fill: "#1e1e1c"
});

var _ref7 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 43.23,
  cy: 60.43,
  r: 1.3,
  fill: "#1e1e1c"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82.66 28.8c-.79 1.19-9.11 8.54-15.94 14.57-.18.57-.34 1.28-.78 1.73l-.44.39c-.59.59-1.61.93-2.37 1.05-7.79 6.9-8.36 7.45-9.91 8.86l-.05 4.34c1.61-1.7 8.97-8.33 15.25-13.88 10.75-9.5 15.92-14.12 16.77-15.46 1.32-2.07 3.68-7.61-2.99-14.28-5.83-5.83-11.88-3.94-14.54-1.9-2.27 1.74-12.47 13.75-15.95 17.87-.49.58.04.9-.15 1.11l1.18 1.7c.19-.47.1-1.39.48-1.77l.42-.36c.43-.43 1.07-.64 1.61-.83.45-.53 1.11-.7 1.58-1.25-1.45-.15-2.84-.01-4.07.42 1.37-1.11 3.11-1.51 4.77-1.24 5.07-5.93 10.62-12.24 11.95-13.27.52-.4 5.22-3.73 10.59 1.64 4.7 4.72 4 8.35 2.59 10.56zM48.41 65.35c.68-.77-.28-2.06-.05-2.32l-.42-.83c-.17.62-.51 1.21-.92 1.82l-.61.15c-.54.34-1.1.64-1.7.82-5.68 6.36-12.68 14.04-14.19 15.2-.52.4-5.22 3.73-10.59-1.64-4.7-4.7-4-8.33-2.59-10.54.8-1.2 9.35-8.75 16.23-14.82.39-.34.64-.78 1.01-1.1l.34-.22c.15-.15.91-.69 1.08-.82 8.7-7.68 10.06-8.98 11.6-10.41l-.44-3.85c-1.42 1.65-9.22 8.54-15.57 14.15-10.75 9.49-15.91 14.11-16.77 15.46-1.32 2.07-3.68 7.61 2.99 14.28 5.83 5.83 11.88 3.94 14.54 1.9 2.18-1.7 12.18-12.87 16.06-17.23z",
  fill: "#1e1e1c"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/media/snowboard.e00a4d18.svg";
export { SvgComponent as ReactComponent };